export default __webpack_public_path__ + "static/media/DMA.8370d1ba.svg";